/**
 * @generated SignedSource<<c7a49776ff58343d11300ef14569fe3c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ReportSales$data = {
  readonly " $fragmentSpreads": FragmentRefs<"ReportSummaryData">;
  readonly " $fragmentType": "ReportSales";
};
export type ReportSales$key = {
  readonly " $data"?: ReportSales$data;
  readonly " $fragmentSpreads": FragmentRefs<"ReportSales">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ReportSales",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ReportSummaryData"
    }
  ],
  "type": "Sales",
  "abstractKey": "__isSales"
};

(node as any).hash = "f46df2be673e273d20b8df3b37d73a5e";

export default node;
